
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [ngClass]="{'general-disabled':isMigrationActive}">
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Enter additional information for this project:</p>
      </div>
      <div class="float-right">
        <button class="btn btn-outline-danger" type="button" (click)="rejectProject()"><span class="oi oi-warning"></span> {{ projectRejected ? 'Update Project Rejection' : 'Reject Project' }}</button>
      </div>
    </div>
  </div>
  <form [formGroup]="deliveryInfoForm" (ngSubmit)="autoNextStep()">
    <fieldset [disabled]="isLocked || !workflowTargetInfo.correctRole">
      <div class="row justify-content-md-center">
        <div class="col-md-10 card-block">
          <error [error]="error"></error>
          <div class="row">
            <div class="form-group col-md-6">
              <label class="required" for="csa">CSSA number:</label>
              <input class="form-control" id="csa" type="text" formControlName="csa" name="csa" maxlength="30" required>
            </div>
            <div class="form-group col-md-6">
              <label class="required" for="ampId">AMP ID:</label>
              <input class="form-control" id="ampId" type="text" formControlName="ampId" name="ampId" maxlength="30" required>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6" *ngIf="showMsId">
              <label class="required" for="msId">MS ID:</label>
              <input class="form-control" id="msId" type="text" formControlName="msId" name="msId" maxlength="30" required>
            </div>
            <div class="form-group col-md-6">
              <label for="customerErpNumber">HP Customer Number (SANDY):</label>
              <input class="form-control" id="customerErpNumber" type="text" formControlName="customerErpNumber" name="customerErpNumber" maxlength="40">
            </div>
            <div class="form-group col-md-6">
              <label for="handoverIdNumber">Handover ID Number:</label>
              <input class="form-control" id="handoverIdNumber" type="text" formControlName="handoverIdNumber" name="handoverIdNumber" maxlength="40">
            </div>
            <div class="form-group col-md-6">
              <label for="opgNumber">OPG Number:</label>
              <input class="form-control" id="opgNumber" type="text" formControlName="opgNumber" name="opgNumber" maxlength="50">
            </div>
            <div class="form-group col-md-6">
              <label class="required">Initial Billing Date:
                <help-dialog-button fieldName="Initial Billing Date" helpString="The customer will be billed on this day each month."></help-dialog-button>
              </label>
              <select class="form-control" type="text" formControlName="initialBillingDate" name="initialBillingDate" required>
                <option value="1">Beginning of the month (1st)</option>
                <option value="15">Middle of the month (15th)</option>
              </select>
            </div>
            <div class="form-group col-md-6">
              <label class="required">Billing Frequency:</label>
              <select class="form-control" type="text" formControlName="billingStart" name="billingStart" required>
                <option value="1">Monthly</option>
                <option value="15">2 Week</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6" *ngIf="sourceDocumentationLink">
              <label>Source Documentation Link:</label>
              <p><a class="break-word" [href]="sourceDocumentationLink" target="_blank">{{ sourceDocumentationLink }}</a></p>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label class="required">Order Acceptance:</label>
              <select class="form-control" type="text" formControlName="orderAcceptance" name="orderAcceptance" required>
                <option></option>
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
            </div>
            <div class="form-group col-md-6">
              <label class="required">Order Acceptance Completion Date:</label>
              <div class="input-group">
                <input class="form-control" id="orderAcceptanceCompleteDate" formControlName="orderAcceptanceCompleteDate" type="text" [value]="deliveryInfoForm.controls.orderAcceptanceCompleteDate?.value">
                <datepicker class="right input-group-append" id="orderAcceptanceCompleteDatePicker" formControlName="orderAcceptanceCompleteDate" [value]="deliveryInfoForm.controls.orderAcceptanceCompleteDate?.value"></datepicker>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="required">Allow site design and ordering to exceed quantities specified in the DART deal:</label>
            <select class="form-control" type="text" formControlName="enableCatalogPricing" name="enableCatalogPricing" required>
              <option></option>
              <option [ngValue]="true">Yes</option>
              <option [ngValue]="false">No</option>
            </select>
          </div>
          <div class="form-group">
            <label class="required">Enable Bulk Ordering</label>
            <select class="form-control" type="text" formControlName="enableBulkOrdering" name="enableBulkOrdering" required>
              <option></option>
              <option [ngValue]="true">Yes</option>
              <option [ngValue]="false">No</option>
            </select>
          </div>
          <h5>Bill-To Address:</h5>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" for="name1">Address Name 1:</label>
              <input class="form-control" id="name1" type="text" formControlName="billToAddressName1" name="name1" maxlength="128" required>
            </div>
            <div class="form-group col md-6">
              <label for="name2">Address Name 2:</label>
              <input class="form-control" id="name2" type="text" formControlName="billToAddressName2" name="name2" maxlength="128">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" for="line1">Address Line 1:</label>
              <input class="form-control" id="line1" type="text" formControlName="billToAddressLine1" name="line1" maxlength="128" required>
            </div>
            <div class="form-group col-lg-6">
              <label for="line2">Address Line 2:</label>
              <input class="form-control" id="line2" type="text" formControlName="billToAddressLine2" name="line2" maxlength="128">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" [for]="'country'">Country:</label>
              <select-country [inputId]="'country'" formControlName="billToAddressCountry" name="billToAddressCountry" [inputName]="'country'"></select-country>
            </div>
            <div class="form-group col-lg-6">
              <label class="required" for="city">City:</label>
              <input class="form-control" id="city" type="text" formControlName="billToAddressCity" name="city" maxlength="128" required>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label [for]="'region'">Region:</label>
              <select-region [inputId]="'region'" formControlName="billToAddressRegion" [inputName]="'region'" [countryId]="deliveryInfoForm.value.billToAddressCountry"></select-region>
            </div>
            <div class="form-group col-lg-6">
              <label for="postalCode">Postal Code:</label>
              <input class="form-control" id="postalCode" type="text" formControlName="billToAddressPostalCode" maxlength="10" name="postalCode">
            </div>
          </div>
          <h5>Bill-To Contact:</h5>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" for="firstName">First Name:</label>
              <input class="form-control" id="firstName" type="text" formControlName="billToContactFirstName" name="firstName" maxlength="128" required>
            </div>
            <div class="form-group col-lg-6">
              <label class="required" for="lastName">Last Name:</label>
              <input class="form-control" id="lastName" type="text" formControlName="billToContactLastName" name="lastName" maxlength="128" required>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" for="email">Email Address:</label>
              <input class="form-control" id="email" formControlName="billToContactEmailAddress" name="emailAddress" type="email" required>
            </div>
            <div class="form-group col-lg-6">
              <label class="required" for="phoneNumber">Phone Number:</label>
              <input class="form-control" id="phoneNumber" type="text" formControlName="billToContactPhoneNumber" name="phoneNumber" maxlength="128" required>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-6">
              <label for="modifyContactPhoneNumber2">Phone Number 2</label>
              <input class="form-control" id="modifyContactPhoneNumber2" type="text" formControlName="billToContactPhoneNumber2" name="billToContactPhoneNumber2">
            </div>
            <div class="form-group col-sm-6">
              <label [for]="'contactLocale'">Locale</label>
              <select-contact-locale [inputId]="'contactLocale'" formControlName="billToContactLocale" name="billToContactLocale" [inputName]="'contactLocale'"></select-contact-locale>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </form>
</div>